import Imprint from './Imprint'

export default Imprint
